<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <BaseCard
              :loading-allowed="false"
              :v-card-text-class="'pa-0'"
              icon="mdi-filter-variant"
              title="Sales Team Filter"
          >
            <v-form @submit.prevent="submit">
              <v-row class="pa-2">
                  <v-col cols="12" lg="3" md="2" sm="6">
                    <v-date-input
                      v-model="from_date.value.value"
                      :error-messages="from_date.errorMessage.value"
                      autocomplete="off"
                      bg-color="grey-lighten-4" clearable density="compact"
                      input-format="dd/mm/yyyy"
                      hide-details="auto"
                      label="From Date"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar-month" single-line variant="outlined"
                    />
                  </v-col>
                  <v-col cols="12" lg="3" md="2" sm="6">
                    <v-date-input
                      v-model="to_date.value.value"
                      :error-messages="to_date.errorMessage.value"
                      autocomplete="off"
                      bg-color="grey-lighten-4"
                      clearable density="compact"
                      hide-details="auto"
                      input-format="dd/mm/yyyy"
                      label="To Date"
                      prepend-icon=""
                      prepend-inner-icon="mdi-calendar-month" single-line variant="outlined"/>
                  </v-col>
                </v-row>
              <v-divider></v-divider>
              <v-card-actions class="justify-end">
                <v-btn
                    ref="searchButton"
                    class="bg-brand"
                    prepend-icon="mdi-magnify"
                    type="submit"
                >
                  Search
                </v-btn>
              </v-card-actions>
            </v-form>
          </BaseCard>
        </v-col>

        <v-col cols="12">
          <BaseCard
              :loading-allowed="false"
              :v-card-text-class="'pa-0'"
              icon="mdi-clipboard-text-outline"
              title="Sales Team List"
          >
            <v-row align="center" class="py-2 px-1">
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="search"
                  append-inner-icon="mdi-magnify"
                  bg-color="grey-lighten-4"
                  clearable density="compact"
                  hide-details
                  label="Search"
                  single-line
                  variant="outlined"/>
              </v-col>
              <v-col cols="12" md="4">
                <div class="d-flex align-center flex-column">
                  <v-btn-group density="compact" divided size="small" variant="outlined">
                    <v-btn
                      color="success"
                      prepend-icon="mdi-download"
                      variant="flat"
                      @click="exportToCSV"
                    >
                      CSV
                    </v-btn>
                    <v-btn
                    color="primary"
                    prepend-icon="mdi-download"
                    variant="flat"
                   @click="exportToExcel"
                    >
                      EXCEL
                    </v-btn>
                    <v-btn
                      color="red"
                      prepend-icon="mdi-download"
                      variant="flat"
                      @click="exportToPDF"
                    >
                      PDF
                    </v-btn>
                  </v-btn-group>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="text-right pr-2">
                  <v-btn
                    v-if="$insertAccess($route.fullPath)"
                   color="primary"
                    prepend-icon="mdi-plus"
                    rounded="xl"
                    variant="tonal"
                    @click="goTo('/sales/add-sales-team')"
                  >
                    Add Sales Team
                  </v-btn>
                </div>
              </v-col>
            </v-row>

            <v-data-table
              v-model:items-per-page="itemsPerPage"
              :headers="headers"
              :hover="true"
              :items="getSchema"
              :loading="loading"
              :search="search"
              density="compact"
            >
              <template v-slot:loader>
                <v-progress-linear
                    :color="loading"
                    height="3"
                    indeterminate
                />
              </template>
              <template v-slot:item.index="{ index }">{{ ++index }}</template>
              <template v-slot:item.status="{ item }">
                <v-chip
                    v-if="item.status == 1"
                    class="text-capitalize"
                    color="success"
                    size="small"
                >
                  Active
                </v-chip>
                <v-chip
                  v-else
                  class="text-capitalize"
                  color="red"
                  size="small"
                >
                  Inactive
                </v-chip>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                  v-if="$updateAccess($route.fullPath)"
                  class="me-2 edit-button"
                  color="primary"
                  title="Edit"
                  @click="editItem(item)"
                >
                  mdi-pencil-outline
                </v-icon>
              </template>
            </v-data-table>
          </BaseCard>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import BaseCard from "@/components/utils/baseCard.vue";

export default {
  components: {
    BaseCard
  },
    data: () => ({
        itemsPerPage: 10,
        loading: false,
        search: "",
        dialog: false,
        data: {},
        headers: [
          { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
          { title: "Code", key: "code", align: "left", sortable: false },
          { title: "Team Name", key: "team_name", align: "left", sortable: false},
          { title: "Team Members", key: "team_members.length", align: "left", sortable: false},
          { title: "Department", key: "department.name", align: "left", sortable: false},
          { title: "Total Target", key: "total_team_target_amount", align: "left", sortable: false},
          { title: "Status", align: "center", key: "status", sortable: true },
          { title: "Actions", align: "center", key: "actions", sortable: false },
        ],
    }),
    watch: {},
    created() {
    },
    computed: {
        getSchema() {
          return this.$store.getters.getSalesTeams;
        },
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
          validationSchema: yup.object({
              // from_date: yup.date().required().label("From Date"),
              // to_date: yup.date().required().label("To Date"),
          }),
        });

        const from_date = useField("from_date");
        const to_date = useField("to_date");
        const errorMessages = ref("");
        const loading = ref("");
        const store = useStore();
        const submit = handleSubmit((values) => {
          loading.value = "blue-darken-3";
          values.from_date = formattedDate(from_date.value.value);
          values.to_date = formattedDate(to_date.value.value);
          store
              .dispatch("getSalesTeams", values)
              .then((response) => {
                loading.value = false;
              })
              .catch((error) => {
                toast.error(error.response.data.message);
              });
        });
        return {
          submit,
          from_date,
          to_date,
          errorMessages,
          loading,
        };
    },

    methods: {
        goTo(val) {
            this.$router.push({ path: val }).catch((err) => {});
        },
        editItem(item) {
            this.$store.commit("setEditingSalesTeams", item);
            this.$router.push({ name: "add-sales-team" });
        },
        exportToPDF() {
          let serialNumber = 1;
          const columns = [ "#SL", "Code", "Team Name", "Department", "Status" ];
          const rows = this.getSchema.map((item) => [ serialNumber++, item.code, item.team_name, item.department.name, item.status == 1 ? "Active" : "Inactive"]);
          this.$exportTableToPDF( columns, rows, "Sales Team List", "sls_team_list_" + this.$fileDate());
        },

        exportToExcel() {
          var data = [["#SL", "Code", "Team Name", "Department", "Status"]];
          var serialNumber = 1;
          this.getSchema.forEach((item) => {
              data.push([ serialNumber++, item.code, item.team_name, item.department.name, item.status == 1 ? "Active" : "Inactive"]);
          });
          this.$exportTableToExcel(data, "sls_team_list_" + this.$fileDate());
        },
        
        exportToCSV() {
          var data = [["#SL", "Code", "Team Name", "Department", "Status"]];
          var serialNumber = 1;
          this.getSchema.forEach((item) => {
              data.push([ serialNumber++, item.code, item.team_name, item.department.name, item.status == 1 ? "Active" : "Inactive" ]);
          });

          this.$exportTableToCSV(data, "sls_team_list_" + this.$fileDate());
        },
    },

    mounted() {
      this.from_date.value.value = new Date();
      this.to_date.value.value = new Date();
      this.$nextTick(() => {
        this.$refs.searchButton.$el.click();
      });
    },
};
</script>
